/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

/**
 * Properties mapper for the SelectPointInteraction
 */

/**
 * Export the mapper
 */
export default {
    /**
     * Map itemData properties to interaction props
     * @param {Object} properties
     * @returns {Object} mapped properties
     */
    mapProperties(properties) {
        // for clarity, move the image object under a more expressive property name
        if (properties.object) {
            properties.imgObject = properties.object;
            delete properties.object;
        }
        return properties;
    }
};
